export const comparisonRows = [
  {
    id: 'cost',
    label: 'Cost to get started',
    goldwarden: { text: 'Free — no license, no subscription', good: true },
    generic: { text: '$200 – $1,500 up front', good: false },
    manual: { text: 'Free, but paid in your time', good: false },
  },
  {
    id: 'recovery',
    label: 'Losing-streak handling',
    goldwarden: { text: 'Fixed fractional risk, never averages down', good: true },
    generic: { text: 'Often martingale or grid to mask losses', good: false },
    manual: { text: 'Emotion-driven doubling down', good: false },
  },
  {
    id: 'stops',
    label: 'Stop-loss discipline',
    goldwarden: { text: 'Hard SL attached to every single order', good: true },
    generic: { text: 'Frequently none, or moved when losing', good: false },
    manual: { text: 'Rarely respected under pressure', good: false },
  },
  {
    id: 'setup',
    label: 'Setup effort',
    goldwarden: { text: 'About 5 minutes, one chart, preset included', good: true },
    generic: { text: 'Long config files and tinkering', good: false },
    manual: { text: 'Weeks of screen time to learn', good: false },
  },
  {
    id: 'attention',
    label: 'Daily attention needed',
    goldwarden: { text: 'Fully automated, runs unattended', good: true },
    generic: { text: 'Automated, but needs babysitting', good: false },
    manual: { text: 'Several hours watching charts', good: false },
  },
  {
    id: 'proof',
    label: 'Track record transparency',
    goldwarden: { text: 'Full live-account record shown here', good: true },
    generic: { text: 'Backtest screenshots only', good: false },
    manual: { text: 'Your own notes and memory', good: false },
  },
  {
    id: 'emotion',
    label: 'Emotional bias',
    goldwarden: { text: 'None — rules executed every time', good: true },
    generic: { text: 'Low, but risk model may be blind', good: false },
    manual: { text: 'High — fear and greed decide', good: false },
  },
];